import axios from 'axios';
import { getAuthHeaders } from './userController';

// URL base de la API para equipos
const BASE_URL = 'https://autoseguro.api.ikeytechnologies.com/equipos/';

// Obtener todos los equipos
export const fetchEquipos = async () => {
  try {
    const response = await axios.get(BASE_URL,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener los equipos:', error);
    throw error;
  }
};

// Obtener un equipo específico
export const fetchEquipo = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}${id}/`,getAuthHeaders());
    console.log(response.data)
    return response.data;
    
  } catch (error) {
    console.error('Error al obtener el equipo:', error);
    throw error;
  }
};

// Crear un nuevo equipo
export const createEquipo = async (equipoData) => {
  try {
    const response = await axios.post(BASE_URL, equipoData,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al crear el equipo:', error);
    throw error;
  }
};

// Actualizar un equipo
export const updateEquipo = async (id, equipoData) => {
  try {
    const response = await axios.put(`${BASE_URL}${id}/`, equipoData,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al actualizar el equipo:', error);
    throw error;
  }
};

// Eliminar un equipo
export const deleteEquipo = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}${id}/`,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al eliminar el equipo:', error);
    throw error;
  }
};
